import {convertToURLDatetime} from '@domain/shared'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {Stack, Box} from '@mui/material'
import {MonthRangeSelect} from '@widgets/planning-time-controls'

import {useLongTermPlanBoundary, useSearchParams, useSelectedTimeframe} from '../../hooks'
import type {MomentRange} from '../../types'
import {PlanningScopeSelect} from '../shared'

export const MonthlyProductionPlanningActions = () => {
  const {selectedTimeframe, setSelectedTimeframe} = useSelectedTimeframe()
  const timezoneId = useUpmPlantTimezone()
  if (!selectedTimeframe) {
    throw new Error('BUG: selectedTimeframe is not defined')
  }
  const boundary = useLongTermPlanBoundary()

  const [, setSearchParams] = useSearchParams('start', 'end')

  const handleTimeframeChange = (timeframe: MomentRange) => {
    // TODO validate if it's a monthly timeframe
    setSelectedTimeframe(timeframe)
    setSearchParams({
      start: convertToURLDatetime(timeframe[0], timezoneId),
      end: convertToURLDatetime(timeframe[1], timezoneId)
    })
  }

  return (
    <Box>
      <Stack direction="row" spacing={1.5} {...dataTestId('monthly_production_planning_actions')}>
        <MonthRangeSelect
          selectedRange={selectedTimeframe}
          setSelectedRange={handleTimeframeChange}
          validDateRange={boundary}
          timezoneId={timezoneId}
        />
        <PlanningScopeSelect />
      </Stack>
    </Box>
  )
}
